import React from "react";
import { Col } from "react-bootstrap";

const StatCard = ({ totalEarnings,label, onClick }) => {
    return (
        <Col xs={6} className="mt-3">
            <div className="driver-dashboard__stat-card"
            onClick={onClick} style={{ cursor: 'pointer' }}>
                <div className="driver-dashboard__stat-header">
                    <span className="driver-dashboard__stat-icon driver-dashboard__stat-icon--dollar">Rs</span>
                    <span className="driver-dashboard__stat-value">{totalEarnings}</span>
                </div>
                <div className="driver-dashboard__stat-label">{label}</div>
            </div>
        </Col>
    )
}

export default StatCard;